import util from "zmfront-framework/src/utils/util"

const zmWeigCollect = {};

zmWeigCollect.outText = "";

zmWeigCollect.cacheStr = '';

zmWeigCollect.getOutText2 = function (param){
    if(!param.deviceCollectText){ //设备采集文本
        util.show('设备采集文本不能为空');
        return;
    }
    if(!param.transRegexp){ //转换正则表达式
        util.show('转换正则表达式不能为空');
        return;
    }
    var reg = new RegExp("" + param.transRegexp,"g");
    if(param.deviceId == 'SXH'){
        if(param.isreverse == 1) {
            var outText = param.deviceCollectText.split("").reverse().join("");
            outText = outText.replace(reg, "").replace(/(^\s*)|(\s*$)/g, "");
            zmWeigCollect.outText = (parseFloat(outText)).toFixed(3);
        } else {
            var outText = param.deviceCollectText.replace(reg, "").replace(/(^\s*)|(\s*$)/g, "");
            zmWeigCollect.outText = (parseFloat(outText)).toFixed(3);
        }
        
    } else if (param.deviceId == 'Dzc2019053000002') {
        let ss = param.deviceCollectText.split(/[\n,]/g);
        if(ss && ss.length > 0){
            for(let i = 0;i<ss.length;i++){
                if(ss[i].startsWith('+') && ss[i].endsWith('kg')){
                    let outText = ss[i].replace(reg, "").replace(/(^\s*)|(\s*$)/g, "");
                    if(param.reOrder) {
                        //outText = outText.replace(/"|{|}/g, "");
                        var outTextArr = outText.split(',');
                        var arr = param.reOrder.split(',');
                        var newText = '';
                        for(var j=0;j<arr.length;j++){
                            if(newText == ''){
                                newText = outTextArr[arr[j]-1];
                            } else {
                                newText = newText + ',' + outTextArr[arr[j]-1];
                            }
                        }
                        zmWeigCollect.outText = newText;
                    } else {
                        zmWeigCollect.outText = outText;
                    }
                }
            }
        }
    } else {
        //去掉左右空格
        var outText = param.deviceCollectText.replace(reg, "").replace(/(^\s*)|(\s*$)/g, "");
        if(param.reOrder) {
            //outText = outText.replace(/"|{|}/g, "");
            var outTextArr = outText.split(',');
            var arr = param.reOrder.split(',');
            var newText = '';
            for(var j=0;j<arr.length;j++){
                if(newText == ''){
                    newText = outTextArr[arr[j]-1];
                } else {
                    newText = newText + ',' + outTextArr[arr[j]-1];
                }
            }
            zmWeigCollect.outText = newText;
        } else {
            zmWeigCollect.outText = outText;
        }
    }

    console.log(zmWeigCollect.outText);
    //返回输出文本
    return zmWeigCollect.outText;
};


zmWeigCollect.getOutText = function (param){
    // 如果是电子秤
    if(param && param.deviceType == '2'){
        if(!param.deviceCollectText){ //设备采集文本
            util.show('设备采集文本不能为空');
            return;
        }
        if(!param.transRegexp){ //转换正则表达式
            util.show('转换正则表达式不能为空');
            return;
        }

        let reg = eval(param.transRegexp);


        let collText = param.deviceCollectText;
        if(zmWeigCollect.cacheStr){
            collText = zmWeigCollect.cacheStr + param.deviceCollectText;
        }

        let match = collText.match(reg);
        if(match && match.length > 0){
            zmWeigCollect.cacheStr = '';
            //去掉左右空格
            let outText = match[match.length -1].replace(/(^\s*)|(\s*$)/g, "");
            //反转处理
            if (param.isreverse && param.isreverse == 1) {
                let reverseText = collText.split("").reverse().join("");
                let match2 = reverseText.match(reg);
                if(match2 && match2.length > 0){
                    zmWeigCollect.outText = match2[match2.length -1];
                }
            } else {
                zmWeigCollect.outText = outText;
            }
        }else{
            zmWeigCollect.cacheStr = collText
        }

        console.log(zmWeigCollect.outText);
        //返回输出文本
        return zmWeigCollect.outText;
    }else{
        return zmWeigCollect.getOutText2(param);
    }

};

export default zmWeigCollect;


// WEBPACK FOOTER //
// /home/jenkins/.jenkins/workspace/tms-saas/code/tms-front/test/tms-front/src/utils/zmWeigCollectService.js